<template>
  <div class="service">
    <div class="header">
      <div class="header-content ">
        <div class="header-enterpise header-blue">成长型企业首选 超高性价比</div>
        <div class="header-tips">
          <div>试用版帮助企业无差别体验办公协作需求</div>
          <div>专业多样化的企业版满足企业源源不断的个性化诉求</div>
        </div>
      </div>
    </div>
    <div class="version">
      <div class="service-title">版本说明</div>
      <div class="service-content">立即体验，可享7天无差别体验企业版功能</div>
      <ul class="version-list">
        <li
          class="version-item point"
          v-for="(item,index) in versionList"
          :class="{'v-animate' : item.animateType == 1, 'v-hide-animate' : item.animateType === 2}"
          :key="index"
           @mouseenter="versionEnter (index)"
            @mouseleave="versionLeave(index)"
           
        >
          <div class="version-title"  :class="{ 'advice' : item.isAdvice,'enterprise-meal' : index == 0,'try-out' : index == 1,'service-package' : index == 2}">
            {{item.title}}
            <img src="../assets/advice.png" class="version-recommend" v-if="index != 1"/>
          </div>
          <div class="version-price" style="font-family:'DAB'" :class="{'version-font' : index != 0}">
            <span v-if="index == 0">￥</span>
            <span class="version-price-num" :class="{'version-price-normal': index != 0}">{{item.price}}</span> 
            <span v-if="index == 0" style="font-weight:300">起</span>
          </div>
          <div class="version-number">{{item.number}}</div>
          <div class="version-btn" @click="goTarget(index)">
            {{item.btnText}}
          </div>
          <div class="version-items">
            <div class="version-detail" v-for="(obj,i) in item.items" :key="i">
              <img src="../assets/gou.png" alt />
              <span>{{obj}}</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="entercombo" ref="entercombo">
      <div class="service-title ">SaaS版套餐</div>
      <div class="service-content">满足企业多样化的个性诉求</div>
      <table >
        <thead>
          <tr>
            <th class="register">注册用户数</th>
            <th>20人套餐</th>
            <th>50人套餐</th>
            <th>100人套餐</th>
            <th>200人套餐</th>
            <th>300人套餐</th>
            <th>500人套餐</th>
            <th>500人以上</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>价格</td>
            <td>¥9,980/年</td>
            <td>¥15,000/年</td>
            <td>¥20,000/年</td>
            <td>¥25,000/年</td>
            <td>¥30,000/年</td>
            <td>¥40,000/年</td>
            <td>
              <!-- <span class="point">联系客服</span>
              <span class="getprice">获取报价</span> -->
              每10人，增加600元/年
            </td>
          </tr>
          <tr class="other">
            <td>其他说明</td>
            <td colspan="7" style="font-family:'DAB'">每用户赠送1GB存储空间，超过空间购买：¥120/10GB/年</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="package" ref="package" :style="packageHeight ? 'height:auto' : 'height:329px'">
        <div class="service-title fle" >
          <div>服务包套餐</div>
        </div>
        <div class="service-list">
            <div class="package-detail " >
                <p class="title">
                    服务事项
                </p>
                <ul>
                    <li>VIP客户群客服</li>
                    <li>5*8 400电话</li>
                    <li>学习视频</li>
                    <li>产品手册</li>
                    <li>产品基础问题解答</li>
                    <li>定期群直播培训</li>
                    <li>钉钉企业认证</li>
                    <li>钉钉组织架构配置</li>
                    <li>OA组织架构同步岗位、角色配置</li>
                    <li>系统权限配置</li>
                    <li>表单+流程5条（在线）</li>
                    <li>PC端门户配置1个（在线）</li>
                    <li>移动端门户开通1个（在线）</li>
                    <li>管理员培训1场（在线）</li>
                    <li>用户使用培训1场（在线）</li>
                    <li>管理层使用培训1场（在线）</li>
                    <li>知识分类配置5条（在线）</li>
                    <li>制度分类配置5条（在线）</li>
                    <li>新闻分类配置3条（在线）</li>
                    <li>社区版块配置3条（在线）</li>
                    <li>新员工任务地图配置1个（在线）</li>
                    <li>专属钉钉配置（在线）</li>
                </ul>
            </div>
            <div class="package-online" @mouseenter="showPackageShadow = 2" :class="{'pagckshadow' :showPackageShadow == 2 }" @mouseleave="showPackageShadow = ''">
                 <p class="title">
                    线上服务包
                </p>
                <p class="title-tips">免费</p>
                <ul>
                    <li><img src="../assets/gou.png" alt=""></li>
                    <li><img src="../assets/gou.png" alt=""></li>
                    <li><img src="../assets/gou.png" alt=""></li>
                    <li><img src="../assets/gou.png" alt=""></li>
                    <li><img src="../assets/gou.png" alt=""></li>
                    <li><img src="../assets/gou.png" alt=""></li>
                    <li>-</li>
                    <li>-</li>
                    <li>-</li>
                    <li>-</li>
                    <li>-</li>
                    <li>-</li>
                    <li>-</li>
                    <li>-</li>
                    <li>-</li>
                    <li>-</li>
                    <li>-</li>
                    <li>-</li>
                    <li>-</li>
                    <li>-</li>
                    <li>-</li>
                    <li>-</li>
                </ul>
            </div>
            <div class="package-base" @mouseenter="showPackageShadow = 3" :class="{'pagckshadow' :showPackageShadow == 3 }" @mouseleave="showPackageShadow = ''">
                 <p class="title">
                    基础服务包
                </p>
                <p class="title-tips">¥15,000/1年有效</p>
                <ul>
                    <li><img src="../assets/gou.png" alt=""></li>
                    <li><img src="../assets/gou.png" alt=""></li>
                    <li><img src="../assets/gou.png" alt=""></li>
                    <li><img src="../assets/gou.png" alt=""></li>
                    <li><img src="../assets/gou.png" alt=""></li>
                    <li><img src="../assets/gou.png" alt=""></li>
                    <li><img src="../assets/gou.png" alt=""></li>
                    <li><img src="../assets/gou.png" alt=""></li>
                    <li><img src="../assets/gou.png" alt=""></li>
                    <li><img src="../assets/gou.png" alt=""></li>
                    <li><img src="../assets/gou.png" alt=""></li>
                    <li><img src="../assets/gou.png" alt=""></li>
                    <li>-</li>
                    <li><img src="../assets/gou.png" alt=""></li>
                    <li><img src="../assets/gou.png" alt=""></li>
                    <li>-</li>
                    <li>-</li>
                    <li>-</li>
                    <li>-</li>
                    <li>-</li>
                    <li>-</li>
                    <li>-</li>
                </ul>
            </div>
            <div class="package-masonry " @mouseenter="showPackageShadow = 4" :class="{'pagckshadow' :showPackageShadow == 4 }" @mouseleave="showPackageShadow = ''">
                     <p class="title">
                    钻石服务包
                </p>
                <p class="title-tips">¥30,000/1年有效</p>
                <ul>
                    <li><img src="../assets/gou.png" alt=""></li>
                    <li><img src="../assets/gou.png" alt=""></li>
                    <li><img src="../assets/gou.png" alt=""></li>
                    <li><img src="../assets/gou.png" alt=""></li>
                    <li><img src="../assets/gou.png" alt=""></li>
                    <li><img src="../assets/gou.png" alt=""></li>
                    <li><img src="../assets/gou.png" alt=""></li>
                    <li><img src="../assets/gou.png" alt=""></li>
                    <li><img src="../assets/gou.png" alt=""></li>
                    <li><img src="../assets/gou.png" alt=""></li>
                    <li><img src="../assets/gou.png" alt=""></li>
                    <li><img src="../assets/gou.png" alt=""></li>
                    <li><img src="../assets/gou.png" alt=""></li>
                    <li><img src="../assets/gou.png" alt=""></li>
                    <li><img src="../assets/gou.png" alt=""></li>
                    <li><img src="../assets/gou.png" alt=""></li>
                    <li><img src="../assets/gou.png" alt=""></li>
                    <li><img src="../assets/gou.png" alt=""></li>
                    <li><img src="../assets/gou.png" alt=""></li>
                    <li><img src="../assets/gou.png" alt=""></li>
                    <li><img src="../assets/gou.png" alt=""></li>
                    <li><img src="../assets/gou.png" alt=""></li>
                </ul>
            </div>
        </div>
        <div  class="close"  @click="showPackage">
            <span>收起</span>
        </div>
        <div class="open" v-if="!packageHeight" @click="showPackage">
            <div class="openPic">
              <div>展开更多</div>
              <!-- <img src="../assets/bbb.png" alt=""> -->
              <img src="../assets/bbb2.png" alt="">
              <!-- <div class="arrow">
                <span>>></span>
              </div> -->
           </div>
        </div>
    </div>
    <div class="special" :style="specialHeight ? 'height:auto' : 'height:300px'">
        <div class="service-title fle">
          <div>专项增值服务</div>
        </div>
        <div class="table-list">
            <table >
              <thead>
                  <tr>
                      <th  style="width:209px">服务事项</th>
                      <th style="width:150px">价格</th>
                      <th style="width:465px">服务标准</th>
                      <th style="width:275px">备注</th>
                  </tr>
              </thead>
              <tbody>
                  <tr>
                      <td>钉钉基础部署服务</td>
                      <td class="price">¥8000/次</td>
                      <td> <span>包括钉钉企业认证、钉钉组织架构、考勤日志审批等配置，详细可参照钉钉官网</span> </td>
                      <td><img src="../assets/gou.png" alt=""></td>
                  </tr>
                  <tr>
                      <td>专属钉钉配置服务</td>
                      <td class="price">¥3000/次</td>
                      <td> <span>启用钉钉专属功能，支持配置钉钉登陆页、皮肤等</span> </td>
                      <td><img src="../assets/gou.png" alt=""></td>
                  </tr>
                  <tr>
                      <td>绑定客户自有域名</td>
                      <td class="price">¥3000/次</td>
                      <td><span>按客户指定的域名绑定访问系统，更有专属感</span></td>
                      <td><span>需要客户自行购买ssl证书</span></td>
                  </tr>
                  <tr>
                      <td>远程视频培训</td>
                      <td class="price">¥800/场</td>
                      <td><span>适用项目启动会宣讲、项目上线培训等场景，包括系统管理员、用户使用、管理层使用培训（课件宣讲）</span></td>
                      <td><span>每场1小时，远程视频专人培训</span></td>
                  </tr>
                  <tr>
                      <td>现场培训（系统管理员）</td>
                      <td class="price">¥2800/场</td>
                      <td><span>适用系统管理员、模块管理员操作培训，包括系统参数调整、权限配置、日志管理等（实操为主+课件宣讲）</span></td>
                      <td>每场2小时，上门现场培训</td>
                  </tr> <tr>
                      <td>现场培训（中高层）</td>
                      <td class="price">¥2800/场</td>
                      <td><span>适用项目启动会宣讲、项目上线培训等场景，侧重管理理念、钉钉布道等（课件宣讲）</span> </td>
                      <td><span>每场2小时，上门现场培训</span></td>
                  </tr> <tr>
                      <td>现场培训（员工）</td>
                      <td class="price">¥2800/场</td>
                      <td><span>适用项目启动会宣讲、项目上线培训等场景，定期新员工集中培训等（课件宣讲）</span></td>
                      <td><span>每场2小时，上门现场培训</span></td>
                  </tr>
                  <tr>
                      <td>流程配置</td>
                      <td class="price">¥1000/个</td>
                      <td>
                        <span>1、表单控件在50个以内，流程步骤在30个以内 </span>
                        <span>2、不含页面 Javascript 脚本及数据库SQL代码</span>
                      </td>
                      <td> <span>需与我方客服代表确认，复杂表单、流程与页面效果再行评估费用</span> </td>
                  </tr>
                  <tr>
                      <td>公文管理模块配置</td>
                      <td class="price">￥3000/次</td>
                      <td><span>适用于购买了公文管理模块的机关政府、国企事业单位。配置公文稿纸、打印模板、审批流程设置。限5份公文稿纸模板设置。</span></td>
                      <td><span>超出服务标准的，需与我方客服代表确认评估增加费用</span> </td>
                  </tr>
                  <tr>
                      <td>节日皮肤包更新</td>
                      <td class="price">¥8000/年</td>
                      <td><span>适用于购买了公文管理模块的机关政府、国企事业单位。配置公文稿纸、打印模板、审批流程设置。限5份公文稿纸模板设置。</span></td>
                      <td><span>一般提前一周通知客户</span></td>
                  </tr>
                  <tr>
                      <td>个性化皮肤定制</td>
                      <td class="price">¥8000/套</td>
                      <td><span>根据企业CI/VI定制系统皮肤1套（如企业司庆皮肤），限PC端</span></td>
                      <td>
                          <span>限两次效果图确认</span>
                      </td>
                  </tr><tr>
                      <td>定制移动门户</td>
                      <td class="price">¥5,000/个</td>
                      <td> <span>定制钉钉移动端工作台，不包括集成开发。与其他第三方系统的集成开发，需额外购买定制开发服务。</span></td>
                      <td><span>第三方应用只非钉钉官方应用和蓝凌软件标准产品</span></td>
                  </tr>
                  <!-- <tr>
                      <td>定制开发</td>
                      <td class="price">¥3,000/人天</td>
                      <td><span>帮助集成客户已有的系统、开发新系统模块等。按工作量评估定价，服务内容可包括：需求调研、定制开发、测试、定制功能上线</span> </td>
                      <td>现场调研和联调、远程开放</td>
                  </tr> -->
              </tbody>
          </table>
          <div class="special-tips">
            注：现场服务目前开放深圳、杭州，其他城市逐步开放现场服务
          </div>
        </div>
        <div  class="close" @click="showSpecial">
            <span>收起</span>
        </div>
        <div class="open" v-if="!specialHeight" @click="showSpecial">
           <div class="openPic">
              <div>展开更多</div>
              <!-- <img src="../assets/bbb.png" alt=""> -->
              <img src="../assets/bbb2.png" alt="">

           </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      versionIndex: "",
      showPackageShadow : "",
      afterPage : false,
      versionList: [
        {
          title: "SaaS版",
          price: "9,980",
          number: "20人起按年起售",
          btnText: "了解更多",
          isAdvice: false,
          animateType : 0,
          items: [
            "如需二次开发，按¥3000/人天收取",
            "每用户赠送1GB存储空间",
            "超过空间购买：¥120/10GB/年"
          ]
        },
        {
          title: "私有部署版",
          price: "按需选配",
          number: "50人起",
          btnText: "详情垂询",
          isAdvice: false,
          animateType : 0,//0是初始状态 1 是激活状态 ，2 是移走状态
          items: ["将智能OA部署到您的私有服务器上，让您拥有完整的个性化、集成化、扩展化以及自定义业务搭建的运行能力。"]
        },
        {
          title: "服务包",
          price: "按包收费",
          number: "1年有效",
          btnText: "了解更多",
          isAdvice: false,
          animateType : 0,
          items: ["服务包为服务包套餐和专业增值服务", "定制化需求一对一跟进"]
        }
      ],
      packageHeight:false,
      specialHeight:false,
    };
  },
  methods: {
    versionEnter(index) {
      this.versionIndex = index;
      this.afterPage = true;
      this.$set(this.versionList[index],'animateType',1)
      if(index==1){
        this.versionList[1].btnText = "4006-222-312"
      }
    },
    versionLeave(index) {
      this.$set(this.versionList[index],'animateType',2)
      this.versionList[1].btnText = "详情垂询"

    },
    goTarget(index) {
      switch (index) {
        case 0 :
        // this.$refs.entercombo.scrollIntoView();
        document.documentElement.scrollTop = document.querySelector('.entercombo').offsetTop - 70
        document.body.scrollTop = document.querySelector('.entercombo').offsetTop - 70
        break;
        case 1 :
          _czc.push(["_trackEvent","版本说明_按钮_详情垂询", "menu", '']);
          // this.$router.push('/scancode');
        break;
        case 2 :
          document.documentElement.scrollTop = document.querySelector('.package').offsetTop - 70
          document.body.scrollTop = document.querySelector('.package').offsetTop - 70
        break;
      }
     
    },
    showPackage(){
      this.packageHeight = !this.packageHeight
      if(this.packageHeight==false){
          document.documentElement.scrollTop = document.querySelector('.package').offsetTop - 120
          document.body.scrollTop = document.querySelector('.package').offsetTop - 120

      };
    },
    showSpecial(){
      this.specialHeight = !this.specialHeight
      if(this.specialHeight==false){
          document.documentElement.scrollTop = document.querySelector('.special').offsetTop - 120
          document.body.scrollTop = document.querySelector('.special').offsetTop - 120

      };
    },
  }
};
</script>

<style lang="less" scoped>
.service {
  width: 100%;
  margin-bottom:120px;
  margin-top:70px;
  .service-title {
    font-size: 28px;
    color: #333333;
    text-align: center;
    line-height: 28px;
    font-weight: normal;
    justify-content: center;
  }
  .service-content {
    font-size: 16px;
    color: #999999;
    text-align: center;
    line-height: 16px;
    margin-top: 30px;
    margin-bottom: 40px;
  }
  .header {
    height: 380px;
    margin: 0 auto;
    text-align: center;
    overflow: hidden;
     background: url('../assets/help_bg.png') 0 0 no-repeat;
    background-size:100% 100%;
      color: white;
      display: flex;
      align-items: center;
      justify-content: center;
    .header-enterpise {
      font-size: 42px;
      text-align: center;
      line-height: 42px;
      padding-bottom: 40px;
    }
    .header-tips {
      font-size: 20px;
      text-align: center;
      line-height: 20px;
      div {
        &:nth-child(1) {
          margin-bottom: 10px;
        }
      }
    }
  }
  .version {
    width: 1200px;
    padding: 0 45px;
    padding-top: 100px;
    margin: 0 auto;
    .version-list {
      display: flex;
      justify-content: space-between;
      .version-item {
        width: 330px;
        height: 470px;
        box-shadow: 0 2px 30px 0 rgba(193, 193, 193, 0.3);
        border-radius: 4px;
        text-align: center;
        cursor: default;
        .version-title {
          font-size: 24px;
          color: #ffffff;
          text-align: center;
          line-height: 28px;
          background: #99cbff;
          height: 78px;
          line-height: 78px;
          overflow: hidden;
          position: relative;
           .version-recommend{
          position:absolute;
          right:0;
          top:0;
          width:60px;
        }
        }
        .advice {
          // background: url("../assets/advice.png") top right no-repeat, #99cbff;
          background: url("../assets/advice.png") top right no-repeat;
          background-size: 60px;
        }
      }
      .v-animate {
      animation: move 1s;
      animation-fill-mode: forwards;
      transform-origin: center center;
  .version-btn{
    // background: #4285F4;
    cursor: pointer;
    animation: bganimate 1s;    
    animation-fill-mode: forwards;
    border:none;
    color:white;
  }
}
.v-hide-animate{
 animation: hidemove 1s;
  animation-fill-mode: forwards;
  transform-origin: center center;
  // .version-btn{
  //   background: #4285F4;
  //   border:none;
  //   color:white;
  // }
}

      .version-price {
        color: #333333;
        text-align: center;
        margin-top: 25px;
        margin-bottom: 10px;
        span {
          font-size: 14px;
          font-weight: 600;
        }
        .version-price-num{
          font-size: 52px;
        }
        .version-price-normal{
          font-size:28px;
          font-weight: normal;
        }
      }
      .version-font{
        font-size:28px;
        margin-top:49px;
      }
      .version-btn {
        width: 126px;
        height: 42px;
        line-height: 40px;
        margin: 0 auto;
        margin-top: 44px;
        margin-bottom: 40px;
        background: #ffffff;
        border: 1px solid #4285f4;
        border-radius: 21px;
        font-size: 16px;
        color: #4285f4;
        text-align: center;
        text-shadow: 0 2px 17px rgba(255, 255, 255, 0.13);
      }
      .version-items {
        width: 300px;
        margin: 0 auto;
        border-top: 1px solid #f2f2f2;
        padding-top: 10px;
      }
      .version-detail {
        font-size: 14px;
        color: #666666;
        line-height: 38px;
        text-align: left;
        // margin-top: 22px;
        img {
          width: 10px;
          height: 10px;
          vertical-align: middle;
          margin-right: 10px;
        }
      }
    }
    .enterprise-meal{
      background:  top right no-repeat,linear-gradient(135deg, #B8CEFF 0%, #99B0FF 100%) !important;
      // background-size: 60px !important;
    }
    .service-package{
      background: top right no-repeat,linear-gradient(135deg, #9CD2FF 0%, #62A7FF 100%) !important;
      // background-size: 60px !important;
    }
  }
  .entercombo {
    width: 1200px;
    margin: 0 auto;
    margin-top: 100px;
    table {
      width: 1108px;
      margin: 0 auto;
      font-size: 14px;
      color: #ffffff;
      text-align: center;
      line-height: 16px;
      margin-top: 51px;
      thead {
        background-image: linear-gradient(-135deg, #b8ceff 0%, #99b0ff 100%);
        height: 79px;
        line-height: 79px;
        box-shadow: 0 2px 30px 0 rgba(193,193,193,0.30);
        th {
          border: 1px solid #f2f2f2;
        }
        .register {
          //   padding:0 70px;
          width: 209px;
          box-sizing: border-box;
        }
      }
      tbody {
        color: #333333;
        tr {
          height: 60px;
          background: rgba(242, 242, 242, 0.3);
          td {
            border: 1px solid #f2f2f2;
          }
          &:nth-child(1) {
            td{
              font-family: 'DAB';
            }
          }
        }
        .concat {
          display: block;
          font-size: 14px;
          color: #4285f4;
        }
        .getprice {
          display: block;
          font-size: 12px;
        }
      }
      .other {
        font-size: 14px;
        background: white;
        color: #999999;
        line-height: 16px;
      }
    }
  }
  .package{
      width:1110px;
      margin:0 auto;
      margin-top:100px;
      overflow: hidden;
      position: relative;
      transition: all 0.8s;
      .service-list{
           display:flex;
           font-size: 14px;
            color: #FFFFFF;
            text-align: center;
            margin-top:50px;
            box-shadow: 0 2px 30px 0 rgba(193,193,193,0.30);
           ul li{
               height:60px;
               line-height: 60px;
               border-right:1px solid #F2F2F2;;
               border-bottom:1px solid #F2F2F2;
               &:nth-last-child(1) {
                   border-bottom: 0;
               }
           }
      }
      .title{
          height:60px;
         line-height: 60px; 
         border-right: 1px solid #F2F2F2;
      }
      .title-tips{
          height:40px;
          line-height: 40px;
          background: rgba(242,242,242,0.3);
          color: #999999;
          border-right:1px solid  #F2F2F2;
          font-family: 'DAB';
      }
      img{
          width:12px;
          height:12px;
      }
        .package-detail{
            width:360px;
          color: #666666;
            .title{
                 height:100px;
                 color:#ffffff;
                line-height: 110px; 
                background-image: linear-gradient(-135deg, #9CD2FF 0%, #62A7FF 100%);         
                 
            }
        }
        .package-online,.package-base,.package-masonry{
            width:251px;
            li{
                color: #DFDFDF;
                font-size:20px;
            }
        }
        .package-online{
            .title{
            background: #62a7ff;
            }   
        }
        .package-base,.package-masonry{
            .title{
             background: rgba(98,167,255,1);
            }  
        }
        .package-masonry{
            ul li{
                border-right:0;
            }
            .title,.title-tips{
                border-right:0;
            }
        }
        
  }
  .special{
      margin:0 auto;
      margin-top:100px;
      width:1110px;
      overflow: hidden;
      position: relative;
        transition: all 0.8s;
      table{
          margin-top:50px;
          font-size: 14px;
            color: #666666;
            text-align: center;
            box-shadow: 0 2px 30px 0 rgba(193,193,193,0.30);
          .price{
              color:#4285F4;
          }
          img{
              width: 12px;
              height:12px;
          }
          thead{
              background-image: linear-gradient(-135deg, #B8CEFF 0%, #99B0FF 100%);
              height:79px;
              line-height: 79px;
              color:white;
              th{
                  border-right:1px solid white;
              }
          }
          tbody{
              tr{
                  background:white;
                  border-right:1px solid #F2F2F2;
                    height:61px;
                    line-height: 61px;
                    td{
                        border:1px solid  #F2F2F2;
                        padding:0 15px;
                        box-sizing: border-box;
                        &:nth-last-child(1) {
                            border:none;
                        }
                         &:nth-child(2) {
                      font-family: 'DAB';
                    }
                    }
                  &:nth-child(2n+1) {
                      background:rgba(242,242,242,0.3);
                  }
                  span{
                      display: block;
                      line-height: 2;
                  }
              }
          }
      }
      .special-tips{
          font-size: 14px;
         color: #999999;
         margin-top:30px;
      }
  }
}
@keyframes move {
  from {
    transform: translateY(0px);
  }
  to {
    transform: translateY(-20px);
  }
}
@keyframes hidemove {
    from {
      transform: translateY(-20px);
    }
    to{
      transform: translateY(0);
    }
}
@keyframes bganimate {
    from {
      background: white;
    }
    to{
      background:#4285F4;
    }
}
.pagckshadow{
  animation: pack 0.5s;
  animation-fill-mode: forwards;
  transform-origin: center center;
  .title{
  background:#A5D1FF !important;
  }
}
@keyframes  pack{
    from {
        box-shadow: 0;
    }
    to{
        box-shadow: 0 4px 30px 0 rgba(192,207,226,0.40);
    }
}
.fle{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 20px;
    border-bottom: 1px solid #F2F2F2;
}
.close{
  text-align: right;
  span{
      display: inline-block;
      color: #4285F4;
      border: 0.8px solid #4285F4;
      border-radius: 21px;
      width: 79px;
      height: 32px;
      font-size: 16px;
      text-align: center;
      line-height: 32px;
      margin-top: 32px;
      cursor: pointer;
      &:hover{
        animation: bganimate 0.5s forwards;
        color:white;
        border:none;
      }
  }
}
.open{
  width:100%;
  height:60px;
  background:linear-gradient(180deg,rgba(255,255,255,1) 0%,rgba(255,255,255,0.8) 100%);
  box-shadow:0px -4px 12px 0px rgba(193,193,193,0.3);
  font-size:14px;
  color:rgba(66,133,244,1);
  position: absolute;
  left: 0;
  bottom: 0;
  cursor: pointer;
  .openPic{
    width: 99px;
    height: 30px;
    border-radius:15px;
    border:1px solid rgba(66,133,244,1);
    line-height: 30px;
    display: flex;
    align-items: center;
    // justify-content: center;
    margin: 30px auto 0;
    >div{
      margin-left: 10px;
    }
    img{
      width: 30px;
      height: 30px;
    }
    &:hover{
      opacity: 0.8;
    }
    &:active{
      font-weight: 500;

    };
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/service.vue